import { Body, Button, ButtonGroup, Grid, GridColumn, Modal, Spinner, useSnackbar } from "@livingdesign/react";
import { CANCEL, OK, SUBMIT } from "../../../constants/actionButtons";
import { BULK_INVOICE_RESUBMIT, RESUBMIT_INVOICE, RESUBMIT_INVOICE_WITH_VALIDATION_ADVISORY, RESUBMIT_INVOICE_WITH_VALIDATION_MSG, RESUBMIT_INVOICE_WITHOUT_VALIDATION_MSG, REVALIDATE_AND_SUBMIT_INVOICES } from "../../../constants/constants";
import { filterPayload } from "../../../helpers/commonUtils";
import { postServiceWithHeaders } from "../../../axios/axios";
import { INVOICE_SERVICE } from "../../../constants/baseURLs";
import { useEffect, useState } from "react";
import { getErrorMessage } from "../../../helpers/utils";
import { BULK_UPDATE_INVOICE_STATUS_SUCCESS_MESSAGE } from "../../../constants/messages";
import { invoiceRevalidateModalText } from "../../../constants/templates";

/**
   * Resubmit confirmation modal.
   */
  const BulkResubmitModal = (props) => {
    const {open, handleModalOpen,invoiceIds,bulkActionLoading,setBulkActionLoading,selectedRowsLength,filteredRowsData, reloadPage} = props
    const [jobId, setJobId] = useState();
    const { addSnack } = useSnackbar();

     useEffect(()=>{
        setJobId()
      },[handleModalOpen])


    const handleSubmit = () => {
        setBulkActionLoading(true)
            const orgInvData = filteredRowsData?.reduce(function(acc, curr) {
                acc[curr['id']] = {
                  organizationInvoiceNumber: curr?.organizationInvoiceNumber,
                  "isPreValidation": curr?.status === "Draft",
                }
               return acc;
              }, {})
            const dataBag = {
                "data":orgInvData
            }
        const invoiceIds = filteredRowsData?.map(item => item.id);
        const body = {
          command:  BULK_INVOICE_RESUBMIT,
          identifiers: invoiceIds.join(","),
          validationType : "SYNC",
          executionType: "ASYNC",
          dataBag: JSON.stringify(dataBag)
        }
        const headers = {
          'Content-Type': `multipart/form-data`,
        };
    
        const filteredBody = filterPayload(body)
        postServiceWithHeaders(
          INVOICE_SERVICE,
          `/jobs/v1/submit`,
          filteredBody,
          headers
        )
        .then((response) => {
          const res = JSON.parse(response?.data)
          setJobId(res?.jobId);
          setBulkActionLoading(false)
        })
        .catch((error) => {
          handleModalOpen(false)
          addSnack({
            message: getErrorMessage(error)
          });
          setBulkActionLoading(false)
        })
      }
    const resubmitModalActions = () => {
        return (
          <Grid>
            <GridColumn sm={5}>
              <ButtonGroup>
                <Button
                  variant="primary"
                  size="small"
                  data-testid="continue-btn"
                  id="continue-btn"
                  onClick={handleSubmit}
                >
                  {bulkActionLoading ? <Spinner size="small" color="white" /> : OK}
                </Button>
              </ButtonGroup>
            </GridColumn>
          </Grid>
        );
      };
    
    const handleClose = () => {
        handleModalOpen(false);
        setJobId();
        reloadPage();
    }
  return (
    <Modal
      onClose={handleClose}
      isOpen={open}
      actions={!jobId && resubmitModalActions()}
      size={
        jobId ?
          "small" :
          "medium"
      }
      title={REVALIDATE_AND_SUBMIT_INVOICES}
      data-testid="makePublicModalOpen"
    >{jobId ?
      <p id="success-message" data-testid="success-message">{BULK_UPDATE_INVOICE_STATUS_SUCCESS_MESSAGE}</p> :
      <Grid>
        <Body as="p" size="large" >
          <div>{invoiceRevalidateModalText({ count: selectedRowsLength })}</div>
          <div>{RESUBMIT_INVOICE_WITH_VALIDATION_MSG}
            <br /><br />
            {RESUBMIT_INVOICE_WITH_VALIDATION_ADVISORY}</div>
        </Body>
      </Grid>
      }
    </Modal>
  );
};

export default BulkResubmitModal;
